import React, { useState } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

function decodeHtmlEntities(str: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

function extractLatexFromHtml(html: string): string {
  // Try to extract LaTeX from HTML if possible
  // For now, return the HTML as-is for editing
  return html;
}

const MathInlineComponent: React.FC<NodeViewProps> = ({
  node,
  updateAttributes,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const rawFormula = node?.attrs?.formula || '';

  // Check if the formula is already HTML (contains HTML tags)
  const isHtmlFormula = rawFormula.includes('<') && rawFormula.includes('>');

  let html = '';
  let latexForEditing = '';

  if (isHtmlFormula) {
    // If it's already HTML, use it directly and extract LaTeX for editing
    html = rawFormula;
    latexForEditing = extractLatexFromHtml(rawFormula);
  } else {
    // If it's LaTeX, render it with KaTeX
    const formula = decodeHtmlEntities(rawFormula);
    latexForEditing = formula;
    try {
      html = katex.renderToString(formula, {
        throwOnError: false,
        displayMode: false,
      });
    } catch (error) {
      html = `<span style="color:red;">Invalid formula</span>`;
    }
  }

  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleSave = (latex: string) => {
    if (updateAttributes) {
      updateAttributes({ formula: latex });
    }
    setIsModalOpen(false);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <NodeViewWrapper
        as="span"
        data-type="math-inline"
        formula={rawFormula}
        className="inline-block px-1"
      >
        <span
          dangerouslySetInnerHTML={{ __html: html }}
          onClick={handleClick}
          className="cursor-pointer hover:bg-gray-100 rounded px-1 min-w-[20px] inline-block transition-colors"
          title="Click to edit formula"
          style={{ minHeight: '1em', display: 'inline-block' }}
        />
      </NodeViewWrapper>
    </>
  );
};

export default MathInlineComponent;
